import {makeStyles} from "@material-ui/core";

export default function useStyles() {
    return makeStyles((theme) => ({
        root: {
            width: '100%',
            position: 'relative',
            overflow: 'auto',            
        },
     
    }));
}